<template>
  <div class="student-side-menu">
    <div class="user-info">
      <a-avatar
        style="backgroundcolor: #87d068"
        shape="square"
        icon="user"
        :src="avatarUrl"
      />
      <h3>{{ userInfo.realname }}</h3>
      <!-- <p>优秀作业 {{userCountInfo.workGreatTotal}}</p>
      <p>(作业总数 {{userCountInfo.workTotal}})</p> -->
    </div>
    <a-divider style="width: 80%"></a-divider>
    <div>
      <a-menu mode="inline" @click="handleClick" v-model="selectedKeys">
        <a-menu-item key="event"
          ><router-link to="event"
            ><a-icon type="fire" />我的活动</router-link
          ></a-menu-item
        >
        <a-menu-item key="cert"
          ><router-link to="cert"
            ><a-icon type="solution" />我的证书</router-link
          ></a-menu-item
        >
        <a-menu-item key="score"
          ><router-link to="score"
            ><a-icon type="check-square" />成绩查询</router-link
          ></a-menu-item
        >
        <!-- <a-menu-item key="work"
          ><router-link to="work"
            ><a-icon type="code" />我的创作</router-link
          ></a-menu-item
        > -->
        <!-- <a-menu-item key="question"
          ><router-link to="question"
            ><a-icon type="ordered-list" />我的题目</router-link
          ></a-menu-item
        > -->
        <a-menu-item key="myPaper"
          ><router-link to="myPaper"
            ><a-icon type="ordered-list" />模拟练习</router-link
          ></a-menu-item
        >
        <a-menu-item key="info"
          ><router-link to="info"
            ><a-icon type="contacts" />个人信息</router-link
          ></a-menu-item
        >
        <a-menu-item key="setting"
          ><router-link to="setting"
            ><a-icon type="setting" />安全设置</router-link
          ></a-menu-item
        >
      </a-menu>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'

export default {
  name: "SideMenuStudent",
  data() {
    return {
      selectedKeys: ["course"],
      userCountInfo: {}
    };
  },
  computed:{
    avatarUrl(){
      if(this.$store.state.user.info && this.$store.state.user.info.avatar){
        if(this.$store.state.user.info.thirdType == "cyscc"){
          return "https://cast-files.oss-cn-beijing.aliyuncs.com/" + this.$store.state.user.info.avatar
        }else{
          return this.getQiniuUrl(this.$store.state.user.info.avatar)
        }
      }else{
        return "/img/avatar.png"
      }
    }
  },
  created() {
    let that = this;
    this.userInfo = this.$store.state.user.info;
    this.selectedKeys[0] = this.$route.name;
    // this.getUserCount()
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
  },
};
</script>

<style lang="less" scoped>
.student-side-menu {
  padding-bottom: 20px;
}
.user-info {
  background-image: url("~@assets/theme/xmw/user-info-bg.png");
  background-size: cover;
  padding-top: 50px;
  .school-area {
    font-size: 14px;
    color: #999;
  }
  .medal {
    width: 40px;
    margin-bottom: 10px;
  }
}
.ant-avatar {
  width: 80px;
  height: 80px;
  padding: 5px;
  background: #fff !important;
}
.ant-menu-item{
  a,i{
    font-size: 18px;
  }
  
}
</style>